import React from 'react';

const SentryTesting = () => {
  // The undefined call is the point: clicking this is how we verify Sentry is
  // capturing and reporting client-side errors. Do not "fix" it by defining or
  // renaming the function — that would make the button silently do nothing.
  // eslint-disable-next-line no-undef -- intentional ReferenceError
  return <button onClick={() => methodDoesNotExist()}>Trigger Error</button>;
};

export default SentryTesting;
